import { Component, inject } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { injectDispatch } from '@ngrx/signals/events';
import {
  SelectInputComponent,
  NumberInputComponent,
  CalendarInputComponent,
} from '@navstation-portal/shared/ui/components';
import {
  AbstractStoreConnectedSectionComponent,
  offshoreOperationalEvents,
  OffshoreOperationalFormStore,
} from '@navstation-portal/reporting/data-access/offshore-report';
import {
  LOCATION_OPTIONS,
  OPERATION_TYPE_OPTIONS,
} from '../../../../reporting-page/report.service';

@Component({
  selector: 're-operating-conditions',
  templateUrl: './operating-conditions.component.html',
  styleUrl: './operating-conditions.component.css',
  imports: [
    FormsModule,
    SelectInputComponent,
    NumberInputComponent,
    CalendarInputComponent,
  ],
})
export class OperatingConditionsComponent extends AbstractStoreConnectedSectionComponent {
  operationTypes = OPERATION_TYPE_OPTIONS;
  locations = LOCATION_OPTIONS;
  tabId = 'operational';
  sectionId = 'operatingConditions';
  events = injectDispatch(offshoreOperationalEvents);
  operationalStore = inject(OffshoreOperationalFormStore);
}
